import React, { Component } from 'react';
import './App.css';
import Gui from './components/gui/gui'
import { Provider } from 'react-redux';
import store from "./reducers/store";
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale-provider/zh_CN'

class App extends Component {
  render() {
    return (
      <ConfigProvider locale={zhCN}>
        <div className="App">
          <Provider store={ store }>
            <Gui></Gui>
          </Provider>
        </div>
      </ConfigProvider>
    );
  }
}

export default App;
